const CustomerType = Object.freeze({
    INDIVIDUAL: 1,
    COMPANY: 2,
    BUSINESS_FOREIGN: 3,
});

export default CustomerType;
